/**
 * Implements a button view that displays the most recent healthcheck status
 */
import Marionette from "backbone.marionette";
import SimpleAlert from "../../utils/alerts/simple";
import HealthCheckUtility from "../../utils/healthcheck";
import Radio from "backbone.radio";

const channel = Radio.channel("global");

const DEFAULTS = {
  el: "footer .healthcheck",
  template: _.template(`
		<button type="button" class="btn btn-sm btn-<%= status %>">
			<i class="fa fa-fw fa-<%= icon %>"></i>&nbsp;<%= label %>
		</button>
	`),
};

class HealthcheckView extends Marionette.ItemView {
  constructor(options = {}) {
    _.defaults(options, DEFAULTS);
    super(options);
  }

  events() {
    return {
      click: "_onClick",
    };
  }

  initialize() {
    this.model = null;

    this.listenTo(channel, "healthcheck:update", this._onUpdate);

    // instantiate utility
    new HealthCheckUtility();
  }

  _onUpdate(model) {
    this.model = model;
    this.render();
  }

  _onClick() {
    const lastUpdated = RVC.Utils.relativeDateFormatter(
      this.model.getLastUpdated()
    );
    const data = this.model
      .getDataSources()
      .map(
        (ds) =>
          `<tr>
					<td>${ds.getName()}</td>
					<td>${ds.getStatus()}</td>
					<td>${ds.getException()}</td>
				</tr>
				`
      )
      .join("");

    new SimpleAlert({
      width: 680,
      type: "info",
      title: "Datasource Health Status",
      text: null,
      html: `
				<div class="text-muted small">Last checked ${lastUpdated}</div>
				<table class="table table-striped table-bordered table-hover">
					<thead>
						<tr>
							<th>Datasource</th>
							<th>Status</th>
							<th>Exception</th>
						</tr>
					</thead>
					<tbody>
						${data}
					</tbody>
				</table>
			`,
      confirmButtonText: "Dismiss",
      confirmButtonClass: "btn btn-emphasized",
    });
  }
}

export { HealthcheckView as default };
